type MicrophoneDialogText = {
  heading: string
  body: string
  button_text: string
  button_voice: string
}

type LanguageConfig = {
  name: string
  code: string
  microphone_dialog_text: MicrophoneDialogText
}
export const MICROPHONE_DIALOG_LANGUAGES: LanguageConfig[] = [
  {
    name: 'English',
    code: 'en-US',
    microphone_dialog_text: {
      heading: 'Enable Voice Conversation?',
      body:
        'Allow microphone access to talk with the assistant. Otherwise, you can type your answers.',
      button_text: 'USE TEXT ONLY',
      button_voice: 'VOICE CONVERSATION',
    },
  },
  {
    name: 'Español',
    code: 'es-US',
    microphone_dialog_text: {
      heading: '¿Habilitar conversación por voz?',
      body:
        'Permitir acceso al micrófono para hablar con el asistente. De lo contrario, puedes escribir tus respuestas.',
      button_text: 'USAR SOLO TEXTO',
      button_voice: 'CONVERSACIÓN POR VOZ',
    },
  },
  {
    name: 'Deutsch',
    code: 'de-DE',
    microphone_dialog_text: {
      heading: 'Sprachkonversation aktivieren?',
      body:
        'Erlauben Sie den Mikrofonzugriff, um mit dem Assistenten zu sprechen. Andernfalls können Sie Ihre Antworten eingeben.',
      button_text: 'NUR TEXT VERWENDEN',
      button_voice: 'SPRACHKONVERSATION',
    },
  },
  {
    name: 'Français',
    code: 'fr-FR',
    microphone_dialog_text: {
      heading: 'Activer la conversation vocale?',
      body:
        "Autoriser l'accès au microphone pour parler avec l'assistant. Sinon, vous pouvez taper vos réponses.",
      button_text: 'UTILISER UNIQUEMENT LE TEXTE',
      button_voice: 'CONVERSATION VOCALE',
    },
  },
  {
    name: 'हिन्दी',
    code: 'hi-IN',
    microphone_dialog_text: {
      heading: 'क्या आवाज़ संवाद सक्षम करें?',
      body:
        'सहायक से बात करने के लिए माइक्रोफोन का उपयोग करने की अनुमति दें। अन्यथा, आप अपने उत्तर टाइप कर सकते हैं।',
      button_text: 'केवल टेक्स्ट का उपयोग करें',
      button_voice: 'आवाज़ संवाद',
    },
  },
  {
    name: 'Português',
    code: 'pt-BR',
    microphone_dialog_text: {
      heading: 'Ativar conversa por voz?',
      body:
        'Permitir acesso ao microfone para conversar com o assistente. Caso contrário, você pode digitar suas respostas.',
      button_text: 'USAR SOMENTE TEXTO',
      button_voice: 'CONVERSA POR VOZ',
    },
  },
  {
    name: 'العربية',
    code: 'ar-XA',
    microphone_dialog_text: {
      heading: 'تمكين المحادثة الصوتية؟',
      body:
        'السماح بالوصول إلى الميكروفون للتحدث مع المساعد. خلاف ذلك، يمكنك كتابة إجاباتك.',
      button_text: 'استخدام النص فقط',
      button_voice: 'محادثة صوتية',
    },
  },
  {
    name: 'Bahasa Indonesia',
    code: 'id-ID',
    microphone_dialog_text: {
      heading: 'Aktifkan percakapan suara?',
      body:
        'Izinkan akses mikrofon untuk berbicara dengan asisten. Jika tidak, Anda dapat mengetik jawaban Anda.',
      button_text: 'GUNAKAN TEKS SAJA',
      button_voice: 'PERCAKAPAN SUARA',
    },
  },
  {
    name: 'Italiano',
    code: 'it-IT',
    microphone_dialog_text: {
      heading: 'Abilitare la conversazione vocale?',
      body:
        "Consenti l'accesso al microfono per parlare con l'assistente. Altrimenti, puoi digitare le tue risposte.",
      button_text: 'USARE SOLO IL TESTO',
      button_voice: 'CONVERSAZIONE VOCALE',
    },
  },
  {
    name: '日本語',
    code: 'ja-JP',
    microphone_dialog_text: {
      heading: '音声会話を有効にしますか?',
      body:
        'アシスタントと話すためにマイクへのアクセスを許可してください。それ以外の場合は、回答を入力できます。',
      button_text: 'テキストのみを使用',
      button_voice: '音声会話',
    },
  },
  {
    name: 'Türkçe',
    code: 'tr-TR',
    microphone_dialog_text: {
      heading: 'Sesli sohbeti etkinleştirilsin mi?',
      body:
        'Asistanla konuşmak için mikrofona erişim izni verin. Aksi takdirde, yanıtlarınızı yazabilirsiniz.',
      button_text: 'SADECE YAZI KULLANIN',
      button_voice: 'SESİLİ SOHBET',
    },
  },
  {
    name: 'Tiếng Việt',
    code: 'vi-VN',
    microphone_dialog_text: {
      heading: 'Kích hoạt cuộc trò chuyện bằng giọng nói?',
      body:
        'Cho phép quyền truy cập vào micro để nói chuyện với trợ lý. Nếu không, bạn có thể nhập câu trả lời của mình.',
      button_text: 'CHỈ SỬ DỤNG VĂN BẢN',
      button_voice: 'CUỘC TRÒ CHUYỆN BẰNG GIỌNG NÓI',
    },
  },
  {
    name: 'বাংলা',
    code: 'bn-IN',
    microphone_dialog_text: {
      heading: 'ভয়েস কথোপকথন সক্ষম করবেন?',
      body:
        'সহকারী সাথে কথা বলার জন্য মাইক্রোফোন অ্যাক্সেস অনুমতি দিন। অন্যথায়, আপনি আপনার উত্তর টাইপ করতে পারেন।',
      button_text: 'শুধুমাত্র টেক্সট ব্যবহার করুন',
      button_voice: 'ভয়েস কথোপকথন',
    },
  },
  {
    name: 'ગુજરાતી',
    code: 'gu-IN',
    microphone_dialog_text: {
      heading: 'વોઇસ કન્વર્સેશન સક્રિય કરવું?',
      body:
        'માઇક્રોફોનને ઍક્સેસ આપો જેથી તમે સહાયક સાથે વાત કરી શકો. નહીંતર, તમે તમારા જવાબો ટાઇપ કરી શકો છો.',
      button_text: 'ફક્ત ટેક્સ્ટનો ઉપયોગ કરો',
      button_voice: 'વોઇસ કન્વર્સેશન',
    },
  },
  {
    name: 'ಕನ್ನಡ',
    code: 'kn-IN',
    microphone_dialog_text: {
      heading: 'ಧ್ವನಿ ಸಂವಾದವನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಬೇಕೆ?',
      body:
        'ಸಹಾಯಕರೊಂದಿಗೆ ಮಾತನಾಡಲು ಮೈಕ್ರೋಫೋನಿಗೆ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿ. ಇಲ್ಲದಿದ್ದರೆ, ನೀವು ನಿಮ್ಮ ಉತ್ತರಗಳನ್ನು ಟೈಪ್ ಮಾಡಬಹುದು.',
      button_text: 'ಕೇವಲ ಪಠ್ಯವನ್ನು ಬಳಸಿ',
      button_voice: 'ಧ್ವನಿ ಸಂವಾದ',
    },
  },
  {
    name: 'മലയാളം',
    code: 'ml-IN',
    microphone_dialog_text: {
      heading: 'ശബ്ദ സംഭാഷണം പ്രവർത്തിപ്പിക്കാമോ?',
      body:
        'അസിസ്റ്റന്റുമായി സംസാരിക്കാൻ മൈക്രോഫോൺ ആക്‌സസ് അനുവദിക്കുക. അല്ലെങ്കിൽ, നിങ്ങൾ നിങ്ങളുടെ ഉത്തരം ടൈപ്പ് ചെയ്യാം.',
      button_text: 'മാത്രം ടെക്‌സ്‌റ്റ് ഉപയോഗിക്കുക',
      button_voice: 'ശബ്ദ സംഭാഷണം',
    },
  },
  {
    name: 'मराठी',
    code: 'mr-IN',
    microphone_dialog_text: {
      heading: 'ध्वनी संभाषण सक्रिय करायचं का?',
      body:
        'सहाय्यकासोबत बोलण्यासाठी मायक्रोफोनला प्रवेश द्या. अन्यथा, आपण आपले उत्तर टाइप करू शकता.',
      button_text: 'फक्त टेक्स्ट वापरा',
      button_voice: 'ध्वनी संभाषण',
    },
  },
  {
    name: 'தமிழ்',
    code: 'ta-IN',
    microphone_dialog_text: {
      heading: 'சப்த உரையாடலை இயக்கு?',
      body:
        'உதவியுடன் பேச மைக்ரோபோனுக்கான அணுகலை அனுமதிக்கவும். இல்லையெனில், நீங்கள் உங்கள் பதில்களை தட்டச்சு செய்யலாம்.',
      button_text: 'பதிவுத்தொடர்புக்கு மட்டும் பயன்படுத்தவும்',
      button_voice: 'சப்த உரையாடல்',
    },
  },
  {
    name: 'తెలుగు',
    code: 'te-IN',
    microphone_dialog_text: {
      heading: 'వాయిస్ చాట్‌ను సక్రియం చేయాలా?',
      body:
        'అసిస్టెంట్‌తో మాట్లాడడానికి మైక్రోఫోన్ యాక్సెస్‌ను అనుమతించండి. లేదంటే, మీరు మీ సమాధానాలను టైప్ చేయవచ్చు.',
      button_text: 'కేవలం టెక్స్ట్ ఉపయోగించండి',
      button_voice: 'వాయిస్ చాట్',
    },
  },
  {
    name: 'Nederlands',
    code: 'nl-NL',
    microphone_dialog_text: {
      heading: 'Stembellen inschakelen?',
      body:
        'Sta toegang tot de microfoon toe om met de assistent te praten. Anders kunt u uw antwoorden typen.',
      button_text: 'ALLEEN TEKST GEBRUIKEN',
      button_voice: 'STEMGESPREK',
    },
  },
  {
    name: '한국어',
    code: 'ko-KR',
    microphone_dialog_text: {
      heading: '음성 대화를 활성화하시겠습니까?',
      body:
        '어시스턴트와 대화하려면 마이크 액세스를 허용하세요. 그렇지 않으면 답변을 입력할 수 있습니다.',
      button_text: '텍스트만 사용',
      button_voice: '음성 대화',
    },
  },
  {
    name: '官话',
    code: 'cmn-CN',
    microphone_dialog_text: {
      heading: '启用语音对话？',
      body: '允许麦克风访问以与助手交谈。否则，您可以输入您的答案。',
      button_text: '仅使用文本',
      button_voice: '语音对话',
    },
  },
  {
    name: 'Polski',
    code: 'pl-PL',
    microphone_dialog_text: {
      heading: 'Włączyć rozmowę głosową?',
      body:
        'Zezwól na dostęp do mikrofonu, aby rozmawiać z asystentem. W przeciwnym razie możesz wpisać swoje odpowiedzi.',
      button_text: 'UŻYWAJ TYLKO TEKSTU',
      button_voice: 'ROZMOWA GŁOSOWA',
    },
  },
  {
    name: 'Русский',
    code: 'ru-RU',
    microphone_dialog_text: {
      heading: 'Включить голосовое общение?',
      body:
        'Разрешите доступ к микрофону для разговора с помощником. В противном случае вы можете вводить свои ответы.',
      button_text: 'ИСПОЛЬЗОВАТЬ ТОЛЬКО ТЕКСТ',
      button_voice: 'ГОЛОСОВОЕ ОБЩЕНИЕ',
    },
  },
  {
    name: 'Kiswahili',
    code: 'sw-KE',
    microphone_dialog_text: {
      heading: 'Washa mazungumzo ya sauti?',
      body:
        'Ruhusu upatikanaji wa kipaza sauti ili kuzungumza na msaidizi. Vinginevyo, unaweza kuandika majibu yako.',
      button_text: 'TUMIA TU NENO',
      button_voice: 'MAZUNGUMZO YA SAUTI',
    },
  },
  {
    name: 'ไทย',
    code: 'th-TH',
    microphone_dialog_text: {
      heading: 'เปิดใช้การสนทนาด้วยเสียง?',
      body:
        'อนุญาตการเข้าถึงไมโครโฟนเพื่อพูดคุยกับผู้ช่วย มิฉะนั้นคุณสามารถพิมพ์คำตอบของคุณได้',
      button_text: 'ใช้เฉพาะข้อความ',
      button_voice: 'การสนทนาด้วยเสียง',
    },
  },
  {
    name: 'اردو',
    code: 'ur-IN',
    microphone_dialog_text: {
      heading: 'آواز کے ساتھ بات چیت فعال کریں؟',
      body:
        'اسسٹنٹ سے بات کرنے کے لیے مائیکروفون تک رسائی کی اجازت دیں۔ بصورت دیگر، آپ اپنے جوابات ٹائپ کر سکتے ہیں۔',
      button_text: 'صرف متن استعمال کریں',
      button_voice: 'آواز کے ساتھ بات چیت',
    },
  },
  {
    name: 'Українська',
    code: 'uk-UA',
    microphone_dialog_text: {
      heading: 'Увімкнути голосову розмову?',
      body:
        'Дозвольте доступ до мікрофону для розмови з помічником. В іншому випадку ви можете ввести свої відповіді.',
      button_text: 'ВИКОРИСТОВУЙТЕ ТІЛЬКИ ТЕКСТ',
      button_voice: 'ГОЛОСОВА РОЗМОВА',
    },
  },
]
